module.exports = __webpack_public_path__ + "img/background_preLogin.d365f1e3.png";